import React, {useState} from 'react';
import ConditionSection from "./ConditionSection";
import NewTabulator from "../../NewTabulator/NewTabulator";
import "./NewDataChartNewTable.scss"

const ConditionInDataChart = (props) => {
  const {hasCondition, setCondition, object, conditionDataFromBackEnd} = props

  const [show, setShow] = useState(props.hasConditionState)
  const checkboxHandler = (e) => {
    const isChecked = e.target.checked;

    setShow(isChecked);

    props.setHasConditionState(isChecked)

  }

  console.log(conditionDataFromBackEnd)

  return (
    <div>
      <div>
        <input id={"show"} type="checkbox" value={show}
               onChange={checkboxHandler}
               checked={show}
        />
        <label htmlFor={"show"}> افزودن شرط</label>
      </div>
      {show && <>

        {Object.keys(conditionDataFromBackEnd).length > 0 && <>
          <ConditionSection {...props} />
          <NewTabulator columns={props.tableColumnsForCondition}
                        data={props.conditionTableData}
                        className={"NewDataChartNewTable"}

          />
        </>
        }
      </>}
    </div>
  );
};

export default ConditionInDataChart;
